package com.evoapps.evoshift.ui.billing

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Lock
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.LightGold
import com.evoapps.evoshift.ui.util.TestTags
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.plan_ended_banner_member
import evoshift.composeapp.generated.resources.plan_ended_banner_owner
import evoshift.composeapp.generated.resources.subscription_upgrade
import org.jetbrains.compose.resources.stringResource

/**
 * Read-only after the plan ended (SH-65): under every main screen while the workplace's plan has
 * ended. Everything stays visible, nothing can be changed; the owner gets "Choose a plan"
 * ([onChoosePlan]), everyone else (null) is told to ask the owner.
 */
@Composable
fun PlanEndedBanner(onChoosePlan: (() -> Unit)?, modifier: Modifier = Modifier) {
    Row(
        modifier = modifier
            .fillMaxWidth()
            .background(DeepNavy)
            .testTag(TestTags.PLAN_ENDED_BANNER)
            .padding(horizontal = 16.dp, vertical = 8.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(12.dp)
    ) {
        Icon(Icons.Default.Lock, contentDescription = null, tint = LightGold, modifier = Modifier.size(20.dp))
        Text(
            stringResource(if (onChoosePlan != null) Res.string.plan_ended_banner_owner else Res.string.plan_ended_banner_member),
            color = Color.White.copy(alpha = 0.9f),
            style = MaterialTheme.typography.bodySmall,
            modifier = Modifier.weight(1f)
        )
        if (onChoosePlan != null) {
            TextButton(onClick = onChoosePlan) {
                Text(stringResource(Res.string.subscription_upgrade), color = LightGold, fontWeight = FontWeight.Bold)
            }
        }
    }
}
